import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { EArea } from "./constants";
export var getAllowedMethods = function getAllowedMethods(getWindow, getIsLoggedIn, getContent) {
  var _getWindow;
  var isElk = !!((_getWindow = getWindow()) !== null && _getWindow !== void 0 && _getWindow.location.pathname.toLowerCase().includes(EArea.AccountDashboard.toLowerCase()));
  var isLoggedIn = getIsLoggedIn();
  var methods = getContent().paymentMethods;
  return Object.entries(methods).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      areas = _ref2[1];
    return [].concat(_toConsumableArray(acc), [isElk && areas.includes(EArea.AccountDashboard) && key, isLoggedIn && !isElk && areas.includes(EArea.Authorized) && key, !isLoggedIn && areas.includes(EArea.Unauthorized) && key]).filter(Boolean);
  }, []);
};